<template>
  <engagement-layout>
    <template #heading>{{ pageHeadingInfo.heading }} </template>

    <template #sub-heading>{{ pageHeadingInfo.subHeading }}</template>

    <template #left-side-bar>
      <div class="left-body-container">
        <adl-input-char-count :fieldInfo="fieldInfo"></adl-input-char-count>
      </div>
    </template>

    <template #right-side-bar>
      <div
        v-if="chartData.length > 0"
        class="right-body-container right-body-white-container"
      >
        <chart-selection
          :chartTabContent="chartTabContent"
          @onSelectedTab="onSelectedTab"
        >
          <template v-slot:tabBody>
            <component
              :is="selectedComponent"
              :chartProperties="chartProperties"
              :chartData="chartData"
              v-if="chartData.length > 0"
            ></component>
          </template>
        </chart-selection>
        <summary-block
          :leftToolSummary="leftToolSummary"
          :rightToolSummary="rightToolSummary"
        ></summary-block>
      </div>
      <div
        class="right-body-container right-body-white-container emptychartbox"
        v-else
      >
        <div class="emptychartboxicon">
          <!-- <mds-icon name="ip-super-sector-sensitive"></mds-icon> -->

          <img alt="nochart" src="../../assets/no-chart-data.svg" />
        </div>
        <div class="emptychartboxpadding">
          {{ emptyMessage }}
        </div>
      </div>
    </template>

    <template #footer>
      <page-footer>
        <template #action-button-left>
          <mds-button
            size="large"
            variation="flat"
            icon="caret-left"
            @click="onBackButtonClick"
          >
            Back
          </mds-button>
        </template>
        <template #action-button-right>
          <mds-button-container right-aligned>
            <mds-button
              type="button"
              variation="secondary"
              @click="cancelButtonClick"
            >
              Cancel
            </mds-button>
            <mds-button
              type="button"
              variation="primary"
              @click="saveButtonClick"
            >
              Save
            </mds-button>
          </mds-button-container>
        </template>
      </page-footer>
    </template>
  </engagement-layout>
</template>

<script>
import { EngagementLayout } from "../../component";
import { PageFooter } from "../../component";
import { ChartArea, ChartBar } from "../tool";
import AdlInputCharCount from "../custom/input-char-count/InputCharCount.vue";
import { SummaryBlock, ChartSelection } from "../../component/tool";
import { MdsButton, MdsButtonContainer } from "@mds/button";

export default {
  props: {
    pageHeadingInfo: {
      type: Object,
    },
    leftToolSummary: {
      type: Array,
    },
    rightToolSummary: {
      type: Array,
    },
    chartTabContent: {
      type: Array,
    },
    chartProperties: {
      type: Object,
    },
    chartData: {
      type: Array,
    },
    selectedComponent: {
      type: String,
    },
    fieldInfo: {
      type: Object,
    },
    emptyChartMessage: {
      type: Object,
    },
  },
  components: {
    MdsButton,
    ChartSelection,
    EngagementLayout,
    SummaryBlock,
    PageFooter,
    MdsButtonContainer,
    AdlInputCharCount,
    ChartArea,
    ChartBar,
  },
  data() {
    return {
      showdropdown: true,
      loading: false,
    };
  },
  computed: {
    emptyMessage() {
      if (this.emptyChartMessage) {
        return this.emptyChartMessage.message;
      } else {
        return "";
      }
    },
  },
  async created() {},
  methods: {
    onSelectedTab(tabId) {
      this.$emit("onChangeChartTab", tabId);
    },
    ListItemChange() {},
    cancelButtonClick() {
      this.$emit("cancelInstance", {});
    },
    saveButtonClick() {
      this.$emit("saveInstance", {});
    },
    onBackButtonClick() {
      this.$emit("onBack", {});
    },
  },
};
</script>

<style lang="scss" scoped>
.left-body-container {
  .engagement-form {
    padding-top: $mds-space-3-x;
    padding-bottom: $mds-space-3-x;
  }
}
</style>
